var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyLight = function SvgEmptyLight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 41,
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 33,
    rx: 32,
    ry: 7,
    style: {
      fill: "rgb(233,233,233)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55,12.76L44.854,1.258C44.367,0.474 43.656,0 42.907,0L21.093,0C20.344,0 19.633,0.474 19.146,1.257L9,12.761L9,22L55,22L55,12.76Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(222,222,222)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.613,15.931C41.613,14.326 42.607,13.001 43.84,13L55,13L55,31.137C55,33.26 53.68,35 52.05,35L11.95,35C10.32,35 9,33.259 9,31.137L9,13L20.16,13C21.393,13 22.387,14.323 22.387,15.928L22.387,15.95C22.387,17.555 23.392,18.851 24.624,18.851L39.376,18.851C40.608,18.851 41.613,17.543 41.613,15.938L41.613,15.931Z",
    style: {
      fill: "rgb(249,249,249)",
      fillRule: "nonzero",
      stroke: "rgb(222,222,222)",
      strokeWidth: 1
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-light.75e75caad3d9c5ffc7834268a94f614d.svg";